/**
 * In-app documentation routes — all resolve under /articles (see articlesRegistry.js).
 */

import { getArticlePath } from './articlesRegistry';

export const helpLinks = {
  businessQuickstart: getArticlePath('business-quickstart'),
  knowledgeBase: getArticlePath('business-knowledge-base'),
  knowledgeRag: getArticlePath('rag-knowledge-base'),
  integrations: getArticlePath('business-integrations'),
  callLogs: getArticlePath('business-call-logs'),
  developerGettingStarted: getArticlePath('developers-getting-started'),
  apiContract: getArticlePath('developers-api-overview'),
  apiReference: getArticlePath('developers-api-reference'),
  transcriptStreaming: getArticlePath('developers-transcript-streaming'),
  mcpOverview: getArticlePath('mcp-overview'),
  analyticsPlanned: getArticlePath('architecture-platform-phases'),
  webhooks: getArticlePath('developers-webhooks'),
  /** Local Swagger — external tool, not an article */
  localSwagger: 'http://localhost:4000/docs',
};

export function isInternalDocLink(href) {
  return typeof href === 'string' && href.startsWith('/');
}

export default helpLinks;
